(function($) {

  $.extend({
    loadingOverlay : function(options) {
      var elem = $(),
        icon = $(),
        html = '',
        settings = {
          tag: 'div',
          errorModifier: 'is-error',
          successModifier: 'is-success',
          doneModifier: 'is-done',
          errorIcon: 'cross',
          successIcon: 'check',
          defaultIcon: 'loading',
          modifier: '',
          modifierBase: 'loading-overlay--',
          template: 'loading-overlay',
          iconSelector: '.js-loading-overlay__icon',
          callback: undefined
        };

      var init = function() {

              // Parse settings
              settings = $.extend(true, {}, settings, options);

              // Process modifier
              if(settings.modifier.length > 0) {

                // Split into array and create var for joining it back up
                var modifierSplit = settings.modifier.split(' '),
                  modifierJoin = '';

                // Loop and append modifier to each
                $.each(modifierSplit, function(i, val) {
                  modifierJoin += settings.modifierBase + val + ' ';
                });

                // Set modifier to processed modifier
                settings.modifier = modifierJoin.trim();
              }

              // Render the template
        html = $.renderTemplate(settings.template, {tag: settings.tag, modifier: settings.modifier});

        // Load the html as a jQuery object
        elem = $(html);

        // Bind any modules
        app.bind(elem);

        // Handle error
        elem.on('error', function() {

          var icon = elem.find(settings.iconSelector);

          elem.removeClass(settings.successModifier);
          elem.addClass(settings.errorModifier);

          icon.attr('data-icon', settings.errorIcon);

          icon.icon();
        });


        // Handle success
        elem.on('success', function() {
          var icon = elem.find(settings.iconSelector);

          elem.removeClass(settings.errorModifier);
          elem.addClass(settings.successModifier);

          icon.attr('data-icon', settings.successIcon);

          icon.icon();
        });

        // Handle show
        elem.on('show', function() {
          elem.removeClass(settings.doneModifier);
        });

        // Handle hide
        elem.on('hide', function() {
          elem.addClass(settings.doneModifier);

          setTimeout(function() {
            elem.remove();
          }, 500);
        });

        // Run callback if set
        if(typeof(settings.callback) == 'function') {
          settings.callback(elem);
        };
      };

      init();
      return this;

    }
  });
}($));
